/**
 * Dandenong Wheels & Castors - Custom JavaScript
 * Complete theme-specific functionality
 */

(function () {
  'use strict';

  // ============================================================
  // CONSOLE FILTER
  // Moved to an inline <script> in theme.liquid so it runs before
  // any deferred/third-party scripts can log. Search theme.liquid
  // for "@DWC: Inline console filter".
  // ============================================================

  // ============================================================
  // CONFIG
  // ============================================================

  const CONFIG = {
    debug: window.location.search.includes('dwc_debug'),
  };

  function log(...args) {
    if (CONFIG.debug) console.log('[DWC]', ...args);
  }

  // ============================================================
  // INIT
  // ============================================================

  function init() {
    log('Initializing DWC Custom Scripts');

    if (CONFIG.debug) initDevMonitoring();

    initProductPageEnhancements();
    initShopifyFormsEmbedHeadingPatch();
    initConsoleSecurityWarning();

    log('DWC Custom Scripts: Initialization complete');
  }

  // ============================================================
  // PRODUCT PAGE ENHANCEMENTS
  // ============================================================

  function initProductPageEnhancements() {
    log('Initializing product page enhancements');

    document.querySelectorAll('a[href^="#product-details"]').forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    enhanceQuantityInputs();
  }

  function enhanceQuantityInputs() {
    document.querySelectorAll('input[type="number"][name="quantity"]').forEach((input) => {
      input.addEventListener('blur', function () {
        const min = parseInt(this.min) || 1;
        if (isNaN(parseInt(this.value)) || parseInt(this.value) < min) this.value = min;
      });

      input.addEventListener('keydown', function (e) {
        if (!(e.ctrlKey || e.metaKey)) return;
        const min = parseInt(this.min) || 1;
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.value = parseInt(this.value || 1) + 10;
          this.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.value = Math.max(min, parseInt(this.value || 1) - 10);
          this.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  // ============================================================
  // SHOPIFY FORMS EMBED HEADING PATCH (shadow DOM)
  // Applies custom h2 font size/weight to shopify-forms-embed instances
  // inside [id^="dwc-form-col-"] containers using data-title-size and
  // data-title-weight attributes on the parent column.
  // ============================================================

function initShopifyFormsEmbedHeadingPatch() {
  log('Initializing Shopify forms embed heading patch');

  function isTargetPage() {
    return window.location.pathname.indexOf('/pages/custom-conveyor-roller-order-form') !== -1;
  }

  function patchEmbedHeading(col) {
    if (!col || !isTargetPage()) return;

    const embed = col.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return;

    const root = embed.shadowRoot;

    root.querySelectorAll('#dwc-h2-patch, #dwc-heading-override, #dwc-page-heading-override').forEach(function (el) {
      el.remove();
    });

    const style = document.createElement('style');
    style.id = 'dwc-page-heading-override';
    style.textContent =
      'h1, h2, .textHeading_2aowh_35 {' +
      ' font-size: 4.8rem !important;' +
      ' font-weight: 1200 !important;' +
      ' line-height: 1.2 !important;' +
      '}';

    root.appendChild(style);

    log('Page-only Shopify form heading override applied');
  }

  function patchAll() {
    document.querySelectorAll('[id^="dwc-form-col-"]').forEach(patchEmbedHeading);
  }

  patchAll();
  document.addEventListener('DOMContentLoaded', patchAll);
  window.addEventListener('load', patchAll);

  new MutationObserver(patchAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  [300, 800, 1500, 2500, 4000].forEach(function (delay) {
    setTimeout(patchAll, delay);
  });
}

  // CONSOLE SECURITY WARNING
  // ============================================================

  function initConsoleSecurityWarning() {
    const year = new Date().getFullYear();
    const mono = 'font-family:Consolas,Monaco,Menlo,monospace;';
    const soft = `${mono}color:CanvasText;font-weight:600;font-size:12px;opacity:.9;`;
    const dim = `${mono}color:CanvasText;font-weight:600;font-size:11px;opacity:.65;`;
    const red = `${mono}color:#f7941e;background:Canvas;padding:1px 4px;border:1px solid #f7941e;font-weight:800;font-size:12px;`;
    const chip = `${mono}color:CanvasText;background:#f7941e;padding:4px 10px;font-weight:900;font-size:15px;`;
    const metaSpacer = `${mono}padding:0 6px;`;
    const metaSite = `${mono}color:#0f8fe0;font-weight:800;font-size:14px;`;
    const metaDot = `${mono}color:CanvasText;font-weight:700;font-size:14px;opacity:.55;`;
    const metaTheme = `${mono}color:#0f8fe0;font-weight:900;font-size:14px;`;
    const metaForward = `${mono}color:#f7941e;font-weight:900;font-size:14px;`;
    const logo1 = `${mono}color:#19b5ff;font-weight:900;font-size:28px;line-height:24px;`;
    const logo2 = `${mono}color:#0f8fe0;font-weight:900;font-size:28px;line-height:24px;`;
    const logo3 = `${mono}color:#005799;font-weight:900;font-size:28px;line-height:24px;`;
    const logoOutline = `${mono}color:#f7941e;font-weight:900;font-size:28px;line-height:24px;`;
    const title = `${mono}color:CanvasText;font-weight:1100;font-size:27.5px;line-height:24px;letter-spacing:1px;`;
    const boxChars = /[╔╗╚╝═║]/;

    function styleAsciiLine(line, fillStyle) {
      let fmt = '';
      const styles = [];
      for (const ch of line) {
        fmt += '%c' + ch;
        styles.push(boxChars.test(ch) ? logoOutline : fillStyle);
      }
      return { fmt, styles };
    }

    const asciiLines = [
      { text: '██████╗ ██╗    ██╗ ██████╗', style: logo1 },
      { text: '██╔══██╗██║    ██║██╔════╝', style: logo1 },
      { text: '██║  ██║██║ █╗ ██║██║     ', style: logo2 },
      { text: '██║  ██║██║███╗██║██║     ', style: logo2 },
      { text: '██████╔╝╚███╔███╔╝╚██████╗', style: logo3 },
      { text: '╚═════╝  ╚══╝╚══╝  ╚═════╝', style: logo3 },
    ];

    let logoFmt = '';
    const logoStyles = [];
    asciiLines.forEach((line) => {
      const styled = styleAsciiLine(line.text, line.style);
      logoFmt += styled.fmt + '\n';
      logoStyles.push(...styled.styles);
    });
    logoFmt += '%cDANDENONG WHEELS & CASTORS';
    logoStyles.push(title);

    console.log(logoFmt, ...logoStyles);

    console.log(
      '%c DWC %c  %cwww.dandenongcastors.com.au%c  •  %cDWC theme v2.3.0%c  •  %cRolling Forward...',
      chip,
      metaSpacer,
      metaSite,
      metaDot,
      metaTheme,
      metaDot,
      metaForward
    );

    console.log(
      '%c⚠ SECURITY NOTICE %c Never paste code into this console unless you understand exactly what it does.',
      red,
      soft
    );

    console.log(
      '%cIf anyone asked you to paste something here, close this tab and contact %csales@dandenongcastors.com.au',
      soft,
      `${mono}color:LinkText;font-weight:800;font-size:12px;`
    );

    console.log('%c© ' + year + ' Dandenong Wheels & Castors', dim);
  }

  // ============================================================
  // ============================================================
  // DEV MONITORING (debug mode only)
  // ============================================================

  function initDevMonitoring() {
    console.log('DWC Theme Scripts: Loaded at ' + new Date().toISOString());
    console.log('DWC Debug Mode: Active');
    console.log('Performance:', {
      readyState: document.readyState,
      loadTime: performance.now().toFixed(2) + 'ms',
    });
  }

  // ============================================================
  // UTILITIES
  // ============================================================

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  function throttle(func, limit) {
    let inThrottle;
    return function (...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  // ============================================================
  // BOOT
  // ============================================================

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    init();
  });

  document.addEventListener('shopify:section:select', () => {
    init();
  });

  window.DWC = window.DWC || {};
  window.DWC.utils = { debounce, throttle, log };
})();
